const routes = {
  home: '/inicio',
  favorites: '/favoritos',
  terms: '/terminos-de-uso',
  privacy: '/politicas-de-privacidad',
  about: '/acerca-de-aplicacion',
  login: '/login',
  admin: '/gestion-administrador',
  addStation: '/agregar-estacion',
  editStation: '/editar/:id',
  manualPage1: '/manual',
  manualPage2: '/manual1',
  manualPage3: '/manual2',
  manualPage4: '/manual3',
  manualPage5: '/manual4',
};

export default routes;
